import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "report-wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title-container" }
const _hoisted_4 = { class: "title is-5" }
const _hoisted_5 = {
  key: 0,
  class: "buttons has-addons"
}
const _hoisted_6 = {
  key: 0,
  class: "chart-inner"
}
const _hoisted_7 = {
  key: 1,
  class: "no-data"
}
const _hoisted_8 = {
  key: 2,
  class: "error-overlay"
}
const _hoisted_9 = { key: 3 }
const _hoisted_10 = {
  key: 4,
  class: "chart-labels"
}

import ChartError from './ChartError.vue';
import ChartNoData from '@/features/reports/components/ChartNoData.vue';
import ChartLabels from '@/features/reports/components/ChartLabels.vue';
import { computed } from 'vue';
import { nanoid } from 'nanoid';


export default /*@__PURE__*/_defineComponent({
  __name: 'Report',
  props: {
  reportId: {
    type: String,
    required: false,
  },
  dataEmpty: {
    type: Boolean,
    default: false,
  },
  loadedData: {
    type: Boolean,
    default: false,
  },
  loadingError: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    required: true,
  },
  tooltipText: {
    type: String,
    default: '',
  },
  noLabels: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const computedReportId = computed(() => props.reportId || nanoid(7));
const loadedAndReturnedData = computed(() => props.loadedData && !props.dataEmpty);
const loadedAndNotReturnedData = computed(() => props.loadedData && props.dataEmpty);

return (_ctx: any,_cache: any) => {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode(_toDisplayString(__props.title) + " ", 1),
          _createVNode(_component_n_tooltip, {
            position: "right",
            text: __props.tooltipText
          }, null, 8, ["text"])
        ])
      ]),
      (loadedAndReturnedData.value && _ctx.$slots['header-addons'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "header-addons")
          ]))
        : _createCommentVNode("", true)
    ]),
    (loadedAndReturnedData.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "chart", _normalizeProps(_guardReactiveProps({ reportId: computedReportId.value })))
        ]))
      : (loadedAndNotReturnedData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(ChartNoData)
          ]))
        : (__props.loadingError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(ChartError)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_n_loading_spinner)
            ])),
    (loadedAndReturnedData.value && !__props.noLabels)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(ChartLabels, { reportId: computedReportId.value }, null, 8, ["reportId"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})